<template>
	<div class="deat_box">
		<div class="box_center"><el-input type="textarea" :autosize="{ minRows: 4, maxRows: 10 }" placeholder="请输入内容" v-model="textarea"></el-input></div>
		<div class="p_flex p_f_e p_m_t_20"><el-button type="success" @click="fs">发送</el-button></div>
	</div>
</template>

<script>
export default {
	data() {
		return {
			textarea: ''
		};
	},
	watch: {
		
	},
	mounted() {},
	methods: {
		fs(){
			if(!this.textarea){
				this.$message.error("回答问题内容不能为空！")
				return
			}
			this.$request.ajax(this).post("/api_teacher/put_question_response",{
					put_question_id:this.$route.query.id,
					teacher_content:this.textarea
			}).then(res=>{
				// console.log(res)
				this.$message({
					message: '回答成功！',
					type: 'success'
				});
				this.$emit("getna",this.textarea,false)
			})
		}
	}
};
</script>

<style lang="scss" scoped>
.deat_box {
	padding: 20px 260px 0;
}
.box_center {
	background-color: #f5f5f5;
	border-radius: 20px;
}
>>> .el-textarea__inner {
	border: none;
	background-color: #f5f5f5;
	padding: 20px;
	font-size: 16px;
	border-radius: 20px;
}
</style>



// WEBPACK FOOTER //
// src/components/homet/news/commponents/errorInput.vue